import { Toaster } from "@/components/ui/sonner";

const AppToastLayer = () => <Toaster />;

export default AppToastLayer;
